(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cg-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.coolGreenTrack) return;
    window.coolGreenTrack = (event, detail = {}) => {
      if (document.querySelector('meta[name="cg-measure-guides"]')?.content !== 'true') return;
      if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event, ...detail});
    };
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-cg-guide-download]');
      if (!link) return;
      window.coolGreenTrack('cg_guide_download', {product_id: link.dataset.productId || null, file_name: new URL(link.href).pathname.split('/').pop(), page_path: location.pathname});
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cg-guide-download"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.cgGuideDownloadsReady) return;
  window.cgGuideDownloadsReady = true;
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[data-cg-guide-download]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const message = key => document.querySelector('meta[name="cg-download-' + key + '"]')?.content || '';
    link.setAttribute('aria-busy', 'true');
    let status = link.parentElement.querySelector('[data-cg-download-status]');
    if (!status) {
      status = document.createElement('p'); status.dataset.cgDownloadStatus = '';
      status.setAttribute('role', 'status'); status.style.fontSize = '13px'; status.style.lineHeight = '1.5';
      link.after(status);
    }
    status.textContent = message('preparing');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(link.href.trim(), {signal:controller.signal});
      if (!response.ok) throw new Error('PDF response');
      const blob = await response.blob();
      if ((await blob.slice(0,5).text()) !== '%PDF-') throw new Error('Not a PDF');
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url; anchor.download = link.dataset.cgDownloadFilename || decodeURIComponent(new URL(link.href).pathname.split('/').pop()) || 'CoolGreen-Guia.pdf';
      document.body.append(anchor); anchor.click(); anchor.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      status.textContent = '';
    } catch (error) {
      status.textContent = message('error') + ' ';
      const fallback = document.createElement('a');
      fallback.href = link.href.trim(); fallback.target = '_blank'; fallback.rel = 'noopener';
      fallback.textContent = message('open'); fallback.style.textDecoration = 'underline';
      status.append(fallback);
    } finally {
      clearTimeout(timeout); link.removeAttribute('aria-busy');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cg-product-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cg-product-addons')) {
  const selections = new WeakMap();

  customElements.define('cg-product-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.rows = Array.from(this.querySelectorAll('[data-cg-addon]'));
      this.component = this.closest('[data-js-product-component]');
      this.pendingVariant = false;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'es', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR'
      });
      this.hidden = this.dataset.hasAddons !== 'true';
      this.restoreSelection();

      this.addEventListener('change', () => this.update(), { signal });
      this.querySelector('.cg-addons__more')?.addEventListener('toggle', () => {
        this.saveSelection();
      }, { signal });
      this.component?.addEventListener('change', event => {
        const picker = event.target.closest('product-variants');
        if (picker?.closest('[data-js-product-component]') === this.component) {
          this.pendingVariant = true;
        }
        if (event.target.matches('[name="quantity"]')) this.update();
      }, { signal, capture: true });
      this.component?.addEventListener('VARIANT_CHANGE', event => {
        if (event.target.closest('[data-js-product-component]') !== this.component) return;
        if (String(event.target.currentVariant?.id || '') === this.dataset.mainVariant) {
          this.pendingVariant = false;
          this.update();
        }
      }, { signal, capture: true });
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    getChoice(row) {
      const input = row.querySelector('[data-addon-check]');
      const select = row.querySelector('[data-addon-variant]');
      const option = select?.selectedOptions[0];
      if (!input || !select || !option) return null;
      const available = this.contains(row) && !row.closest('[hidden]') &&
        !input.disabled && !select.disabled && !option.disabled;
      return { input, select, option, available };
    }

    restoreSelection() {
      const saved = this.component && selections.get(this.component);
      if (!saved || saved.productId !== this.dataset.productId) return;
      const choices = new Map(saved.choices.map(choice => [choice.key, choice]));
      this.rows.forEach(row => {
        const input = row.querySelector('[data-addon-check]');
        const select = row.querySelector('[data-addon-variant]');
        if (!input || !select) return;
        const previous = choices.get(`${row.dataset.kind}:${input.value}`);
        input.checked = false;
        if (!previous) return;
        const option = Array.from(select.options).find(item => {
          return item.value === previous.variantId && !item.disabled;
        });
        if (!option) return;
        select.value = option.value;
        input.checked = previous.checked && !input.disabled && !select.disabled;
      });
      const more = this.querySelector('.cg-addons__more');
      if (more) more.open = saved.moreOpen;
    }

    saveSelection() {
      if (!this.component) return;
      const choices = this.rows.flatMap(row => {
        const choice = this.getChoice(row);
        if (!choice || !choice.available) return [];
        return [{
          key: `${row.dataset.kind}:${choice.input.value}`,
          variantId: choice.select.value,
          checked: choice.input.checked
        }];
      });
      selections.set(this.component, {
        productId: this.dataset.productId,
        choices,
        moreOpen: Boolean(this.querySelector('.cg-addons__more')?.open)
      });
    }

    getItems() {
      const mainInput = this.component?.querySelector('product-form form [name="id"]');
      if (this.pendingVariant || !this.dataset.mainVariant ||
          (mainInput && String(mainInput.value) !== this.dataset.mainVariant)) {
        throw new Error('Plant variant is updating');
      }
      this.update();
      const items = new Map();
      this.rows.forEach(row => {
        const choice = this.getChoice(row);
        if (choice?.available && choice.input.checked) {
          items.set(choice.select.value, { id: Number(choice.select.value), quantity: 1 });
        }
      });
      return Array.from(items.values());
    }

    update() {
      const quantityInput = this.component?.querySelector('product-form form [name="quantity"]');
      const quantity = Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
      let total = Number(this.dataset.mainPrice || 0) * quantity;
      const selected = new Set();

      this.rows.forEach(row => {
        const choice = this.getChoice(row);
        if (!choice) return;
        const { input, select, option, available } = choice;
        if (!available) input.checked = false;
        const price = Number(option.dataset.price || 0);
        const compare = Number(option.dataset.compare || 0);
        row.querySelector('[data-addon-price]').textContent = this.money.format(price / 100);
        const comparison = row.querySelector('[data-addon-compare]');
        comparison.hidden = !(compare > price);
        comparison.textContent = compare > price ? this.money.format(compare / 100) : '';
        const saving = row.querySelector('[data-addon-saving]');
        saving.hidden = !(compare > price);
        saving.textContent = compare > price
          ? row.dataset.saving.replace('[amount]', this.money.format((compare - price) / 100))
          : '';
        if (option.dataset.image) row.querySelector('img')?.setAttribute('src', option.dataset.image);
        if (input.checked && available && !selected.has(select.value)) {
          total += price;
          selected.add(select.value);
        }
      });

      const none = this.querySelector('[data-addon-none]');
      if (none) none.checked = !this.querySelector('[data-kind="pot"] [data-addon-check]:checked');
      const more = this.querySelector('.cg-addons__more');
      const moreSelected = more?.querySelector('[data-addon-more-selected]');
      if (moreSelected) moreSelected.hidden = !more.querySelector('[data-addon-check]:checked');
      const amount = this.querySelector('[data-addon-amount]');
      if (amount) amount.textContent = this.money.format(total / 100);
      this.selection = { total, count: selected.size, quantity, formatted: this.money.format(total / 100) };
      this.saveSelection();
      this.dispatchEvent(new CustomEvent('cg:addons:change', { bubbles: true, detail: this.selection }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-badges"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.cgCardSavingReady) return;
  window.cgCardSavingReady = true;
  document.addEventListener('VARIANT_CHANGE', event => {
    const picker = event.target;
    const card = picker.closest?.('.product-item');
    if (!card) return;
    const badge = card.querySelector('[data-cg-saving-badge]');
    if (!badge) return;
    const variant = picker.currentVariant;
    const saving = picker.noVariantSelectedYet ? Number(badge.dataset.defaultSaving) : (variant ? Number(variant.compare_at_price || 0) - Number(variant.price) : 0);
    badge.hidden = !(saving > 0);
    if (saving > 0) {
      const amount = new Intl.NumberFormat(badge.dataset.locale || 'es', {style:'currency',currency:badge.dataset.currency || 'EUR'}).format(saving / 100);
      badge.textContent = badge.dataset.savingTemplate.replace('[amount]', amount);
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
